import { BrowserRouter } from 'react-router-dom';
import { AppRouter } from './routes/AppRouter';
import { AuthProvider } from './contexts/AuthContext';
import { EnvironmentBanner } from './components/EnvironmentBanner';
import './App.css';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <EnvironmentBanner />
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}
